{
  "$generated": "GENERATED by ax-design-system/build-tokens.mjs — 직접 수정 금지. tokens.json 을 고치고 재생성할 것.",
  "sourceHash": "f73444384392",
  "default": {
    "breakpoint.2xl": {
      "value": 1400,
      "unit": "px"
    },
    "breakpoint.lg": {
      "value": 992,
      "unit": "px"
    },
    "breakpoint.md": {
      "value": 768,
      "unit": "px"
    },
    "breakpoint.sm": {
      "value": 576,
      "unit": "px"
    },
    "breakpoint.xl": {
      "value": 1200,
      "unit": "px"
    },
    "color.bg.canvas": "#f9f9fd",
    "color.bg.danger": "#dd0017",
    "color.bg.danger-hover": "#bb0012",
    "color.bg.danger-pressed": "#99000c",
    "color.bg.danger-subtle": "#ffe7e7",
    "color.bg.danger-subtle-hover": "#ffe2de",
    "color.bg.disabled": "#efefef",
    "color.bg.hover": "#efefef",
    "color.bg.info": "#3163ae",
    "color.bg.info-hover": "#26508f",
    "color.bg.info-pressed": "#204274",
    "color.bg.info-subtle": "#f0f7ff",
    "color.bg.info-subtle-hover": "#e6f0ff",
    "color.bg.inverse": "#333333",
    "color.bg.manager": "#eafbf1",
    "color.bg.memo": "#f5f9ed",
    "color.bg.muted": "#efefef",
    "color.bg.neutral": "#959595",
    "color.bg.overlay": "#00000080",
    "color.bg.pressed": "#e0e0e0",
    "color.bg.primary": "#4cc2b5",
    "color.bg.primary-hover": "#00ada0",
    "color.bg.primary-pressed": "#008f84",
    "color.bg.primary-subtle": "#edfbfa",
    "color.bg.primary-subtle-hover": "#d9f3f2",
    "color.bg.row-hover": "#edfbfa",
    "color.bg.secondary": "#6ad480",
    "color.bg.secondary-hover": "#00bc4f",
    "color.bg.secondary-pressed": "#00a143",
    "color.bg.secondary-subtle": "#eafaec",
    "color.bg.secondary-subtle-hover": "#d0f3d4",
    "color.bg.status-exit": "#00ada0",
    "color.bg.status-impairment": "#5792ea",
    "color.bg.status-partial-exit": "#999ba1",
    "color.bg.status-shutdown": "#d8c600",
    "color.bg.subtle": "#f9f9fd",
    "color.bg.success": "#00893a",
    "color.bg.success-hover": "#007330",
    "color.bg.success-pressed": "#005e26",
    "color.bg.success-subtle": "#dcfce7",
    "color.bg.success-subtle-hover": "#d7f2da",
    "color.bg.surface": "#ffffff",
    "color.bg.tag-filled": "#e0e0e0",
    "color.bg.warning": "#ffc107",
    "color.bg.warning-hover": "#d8a200",
    "color.bg.warning-pressed": "#b78900",
    "color.bg.warning-subtle": "#fff5dc",
    "color.bg.warning-subtle-hover": "#ffeabe",
    "color.black": "#000000",
    "color.black-alpha.50": "#00000080",
    "color.black-alpha.70": "#000000b3",
    "color.border.control": "#828282",
    "color.border.danger": "#dd0017",
    "color.border.default": "#e0e0e0",
    "color.border.focus": "#008f84",
    "color.border.info": "#3163ae",
    "color.border.input": "#efefef",
    "color.border.input-focus": "#00ada0",
    "color.border.primary": "#008f84",
    "color.border.secondary": "#00a143",
    "color.border.subtle": "#efefef",
    "color.border.success": "#00893a",
    "color.border.warning": "#b78900",
    "color.brand.primary": "#00ada0",
    "color.brand.secondary": "#6ad480",
    "color.danger.50": "#ffe7e7",
    "color.danger.100": "#ffe2de",
    "color.danger.200": "#ffccc5",
    "color.danger.300": "#ffa99e",
    "color.danger.400": "#ff7569",
    "color.danger.500": "#ff3131",
    "color.danger.600": "#dd0017",
    "color.danger.700": "#bb0012",
    "color.danger.800": "#99000c",
    "color.danger.900": "#810008",
    "color.danger.950": "#540003",
    "color.dataviz.axis": "#6d6d6d",
    "color.dataviz.baseline": "#e0e0e0",
    "color.dataviz.divider": "#efefef",
    "color.dataviz.gap": "#ffffff",
    "color.dataviz.grade.1": "#ffa99e",
    "color.dataviz.grade.2": "#ffccc5",
    "color.dataviz.grade.3": "#ffda8d",
    "color.dataviz.grade.4": "#c6ddff",
    "color.dataviz.grade.none": "#e0e0e0",
    "color.dataviz.grid": "#efefef",
    "color.dataviz.legend": "#333333",
    "color.dataviz.negative.1": "#ffe7e7",
    "color.dataviz.negative.2": "#ffe2de",
    "color.dataviz.negative.3": "#ffccc5",
    "color.dataviz.negative.4": "#ffa99e",
    "color.dataviz.negative.5": "#ff7569",
    "color.dataviz.negative.6": "#ff3131",
    "color.dataviz.negative.7": "#dd0017",
    "color.dataviz.negative.8": "#bb0012",
    "color.dataviz.negative.9": "#99000c",
    "color.dataviz.negative.10": "#810008",
    "color.dataviz.on-dark": "#ffffff",
    "color.dataviz.on-light": "#333333",
    "color.dataviz.on-tooltip": "#ffffff",
    "color.dataviz.positive.1": "#dcfce7",
    "color.dataviz.positive.2": "#d7f2da",
    "color.dataviz.positive.3": "#b6e7bd",
    "color.dataviz.positive.4": "#86d595",
    "color.dataviz.positive.5": "#4fbb6a",
    "color.dataviz.positive.6": "#16a34a",
    "color.dataviz.positive.7": "#00893a",
    "color.dataviz.positive.8": "#007330",
    "color.dataviz.positive.9": "#005e26",
    "color.dataviz.positive.10": "#004f1e",
    "color.dataviz.series.1": "#00ada0",
    "color.dataviz.series.2": "#00bc4f",
    "color.dataviz.series.3": "#74aafb",
    "color.dataviz.series.4": "#ffc107",
    "color.dataviz.series.5": "#86d9ce",
    "color.dataviz.series.6": "#ff7569",
    "color.dataviz.series.7": "#3e77cd",
    "color.dataviz.series.8": "#b78900",
    "color.dataviz.series.9": "#a7e8b1",
    "color.dataviz.series.10": "#959595",
    "color.dataviz.tooltip": "#333333",
    "color.dataviz.tooltip-divider": "#828282",
    "color.dataviz.track": "#efefef",
    "color.dataviz.trend.down": "#5792ea",
    "color.dataviz.trend.down-text": "#3163ae",
    "color.dataviz.trend.flat": "#828282",
    "color.dataviz.trend.up": "#eb5757",
    "color.dataviz.trend.up-text": "#bb0012",
    "color.dataviz.value": "#00776e",
    "color.fg.danger": "#bb0012",
    "color.fg.default": "#333333",
    "color.fg.disabled": "#a1a1a1",
    "color.fg.info": "#3163ae",
    "color.fg.inverse": "#ffffff",
    "color.fg.metric-primary": "#00ada0",
    "color.fg.muted": "#6d6d6d",
    "color.fg.placeholder": "#6d6d6d",
    "color.fg.primary": "#00776e",
    "color.fg.secondary": "#00722d",
    "color.fg.success": "#007330",
    "color.fg.warning": "#7f5e00",
    "color.info.50": "#f0f7ff",
    "color.info.100": "#e6f0ff",
    "color.info.200": "#c6ddff",
    "color.info.300": "#a1c7ff",
    "color.info.400": "#74aafb",
    "color.info.500": "#5792ea",
    "color.info.600": "#3e77cd",
    "color.info.700": "#3163ae",
    "color.info.800": "#26508f",
    "color.info.900": "#204274",
    "color.info.950": "#10284c",
    "color.neutral.50": "#f9f9fd",
    "color.neutral.100": "#efefef",
    "color.neutral.200": "#e0e0e0",
    "color.neutral.300": "#c1c1c1",
    "color.neutral.400": "#a1a1a1",
    "color.neutral.500": "#959595",
    "color.neutral.600": "#828282",
    "color.neutral.700": "#6d6d6d",
    "color.neutral.800": "#555555",
    "color.neutral.900": "#333333",
    "color.neutral.950": "#0d0d0d",
    "color.on.danger": "#ffffff",
    "color.on.info": "#ffffff",
    "color.on.neutral": "#0d0d0d",
    "color.on.primary": "#0d0d0d",
    "color.on.secondary": "#0d0d0d",
    "color.on.status": "#ffffff",
    "color.on.success": "#ffffff",
    "color.on.warning": "#0d0d0d",
    "color.primary.50": "#edfbfa",
    "color.primary.100": "#d9f3f2",
    "color.primary.200": "#b5e8e1",
    "color.primary.300": "#86d9ce",
    "color.primary.400": "#4cc2b5",
    "color.primary.500": "#00ada0",
    "color.primary.600": "#008f84",
    "color.primary.700": "#00776e",
    "color.primary.800": "#006058",
    "color.primary.900": "#004f49",
    "color.primary.950": "#00312c",
    "color.raw.gray-shadow": "#c4c4c4",
    "color.raw.green-50": "#f5f9ed",
    "color.raw.mint-50": "#eafbf1",
    "color.raw.red-soft": "#eb5757",
    "color.secondary.50": "#eafaec",
    "color.secondary.100": "#d0f3d4",
    "color.secondary.200": "#a7e8b1",
    "color.secondary.300": "#6ad480",
    "color.secondary.400": "#00bc4f",
    "color.secondary.500": "#00a143",
    "color.secondary.600": "#008637",
    "color.secondary.700": "#00722d",
    "color.secondary.800": "#005d23",
    "color.secondary.900": "#004e1c",
    "color.secondary.950": "#003310",
    "color.success.50": "#dcfce7",
    "color.success.100": "#d7f2da",
    "color.success.200": "#b6e7bd",
    "color.success.300": "#86d595",
    "color.success.400": "#4fbb6a",
    "color.success.500": "#16a34a",
    "color.success.600": "#00893a",
    "color.success.700": "#007330",
    "color.success.800": "#005e26",
    "color.success.900": "#004f1e",
    "color.success.950": "#003311",
    "color.warning.50": "#fff5dc",
    "color.warning.100": "#ffeabe",
    "color.warning.200": "#ffda8d",
    "color.warning.300": "#ffc107",
    "color.warning.400": "#d8a200",
    "color.warning.500": "#b78900",
    "color.warning.600": "#987100",
    "color.warning.700": "#7f5e00",
    "color.warning.800": "#674c00",
    "color.warning.900": "#563f00",
    "color.warning.950": "#362600",
    "color.white": "#ffffff",
    "container.content": {
      "value": 1440,
      "unit": "px"
    },
    "font.mono": [
      "ui-monospace",
      "SFMono-Regular",
      "Menlo",
      "monospace"
    ],
    "font.sans": [
      "Pretendard",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Helvetica Neue",
      "Arial",
      "sans-serif"
    ],
    "fontWeight.bold": 700,
    "fontWeight.medium": 500,
    "fontWeight.regular": 400,
    "fontWeight.semibold": 600,
    "motion.duration.base": {
      "value": 200,
      "unit": "ms"
    },
    "motion.duration.fast": {
      "value": 100,
      "unit": "ms"
    },
    "motion.duration.instant": {
      "value": 50,
      "unit": "ms"
    },
    "motion.duration.slow": {
      "value": 300,
      "unit": "ms"
    },
    "motion.duration.slower": {
      "value": 500,
      "unit": "ms"
    },
    "motion.easing.accelerate": [
      0.3,
      0,
      1,
      1
    ],
    "motion.easing.decelerate": [
      0.05,
      0.7,
      0.1,
      1
    ],
    "motion.easing.standard": [
      0.2,
      0,
      0,
      1
    ],
    "opacity.disabled": 0.5,
    "opacity.loading": 0.4,
    "opacity.muted": 0.6,
    "radius.2xl": {
      "value": 12,
      "unit": "px"
    },
    "radius.3xl": {
      "value": 16,
      "unit": "px"
    },
    "radius.4xl": {
      "value": 20,
      "unit": "px"
    },
    "radius.full": {
      "value": 9999,
      "unit": "px"
    },
    "radius.lg": {
      "value": 8,
      "unit": "px"
    },
    "radius.md": {
      "value": 6,
      "unit": "px"
    },
    "radius.none": {
      "value": 0,
      "unit": "px"
    },
    "radius.sm": {
      "value": 4,
      "unit": "px"
    },
    "radius.xl": {
      "value": 10,
      "unit": "px"
    },
    "radius.xs": {
      "value": 2,
      "unit": "px"
    },
    "elevation.card": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 0,
          "unit": "px"
        },
        "blur": {
          "value": 5,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#00000033"
      }
    ],
    "elevation.card-accent": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 0,
          "unit": "px"
        },
        "blur": {
          "value": 5,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#00ada077"
      }
    ],
    "elevation.card-strong": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 0,
          "unit": "px"
        },
        "blur": {
          "value": 5,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#0000004d"
      }
    ],
    "elevation.chip": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 0,
          "unit": "px"
        },
        "blur": {
          "value": 2,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#00000033"
      }
    ],
    "elevation.drawer": [
      {
        "offsetX": {
          "value": -8,
          "unit": "px"
        },
        "offsetY": {
          "value": 0,
          "unit": "px"
        },
        "blur": {
          "value": 24,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#00000026"
      }
    ],
    "elevation.drop": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 5,
          "unit": "px"
        },
        "blur": {
          "value": 5,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#c4c4c4"
      }
    ],
    "elevation.dropdown": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 4,
          "unit": "px"
        },
        "blur": {
          "value": 12,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#0000004d"
      }
    ],
    "elevation.halo": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 0,
          "unit": "px"
        },
        "blur": {
          "value": 10,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#0000001a"
      }
    ],
    "elevation.modal": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 8,
          "unit": "px"
        },
        "blur": {
          "value": 32,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#0000002e"
      }
    ],
    "elevation.popover": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 2,
          "unit": "px"
        },
        "blur": {
          "value": 8,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#0000004d"
      }
    ],
    "elevation.subtle": [
      {
        "offsetX": {
          "value": 0,
          "unit": "px"
        },
        "offsetY": {
          "value": 1,
          "unit": "px"
        },
        "blur": {
          "value": 3,
          "unit": "px"
        },
        "spread": {
          "value": 0,
          "unit": "px"
        },
        "color": "#0000001a"
      }
    ],
    "size.button.2xl": {
      "value": 300,
      "unit": "px"
    },
    "size.button.lg": {
      "value": 140,
      "unit": "px"
    },
    "size.button.md": {
      "value": 120,
      "unit": "px"
    },
    "size.button.sm": {
      "value": 100,
      "unit": "px"
    },
    "size.button.xl": {
      "value": 200,
      "unit": "px"
    },
    "size.button.xs": {
      "value": 80,
      "unit": "px"
    },
    "size.chart.stacked-bar": {
      "value": 388,
      "unit": "px"
    },
    "size.chart.time-series": {
      "value": 352,
      "unit": "px"
    },
    "size.chart.tooltip": {
      "value": 240,
      "unit": "px"
    },
    "size.chart.tooltip-rows": {
      "value": 100,
      "unit": "px"
    },
    "size.chart.treemap": {
      "value": 664,
      "unit": "px"
    },
    "size.chart.treemap-empty": {
      "value": 400,
      "unit": "px"
    },
    "size.container.app": {
      "value": 1440,
      "unit": "px"
    },
    "size.container.drawer": {
      "value": 760,
      "unit": "px"
    },
    "size.container.form": {
      "value": 1000,
      "unit": "px"
    },
    "size.container.page": {
      "value": 1380,
      "unit": "px"
    },
    "size.container.table": {
      "value": 960,
      "unit": "px"
    },
    "size.container.wide": {
      "value": 1200,
      "unit": "px"
    },
    "size.control.2xs": {
      "value": 24,
      "unit": "px"
    },
    "size.control.lg": {
      "value": 48,
      "unit": "px"
    },
    "size.control.md": {
      "value": 40,
      "unit": "px"
    },
    "size.control.sm": {
      "value": 32,
      "unit": "px"
    },
    "size.control.xs": {
      "value": 28,
      "unit": "px"
    },
    "size.dialog.alert": {
      "value": 360,
      "unit": "px"
    },
    "size.dialog.lg": {
      "value": 1200,
      "unit": "px"
    },
    "size.dialog.md": {
      "value": 800,
      "unit": "px"
    },
    "size.dialog.sm": {
      "value": 600,
      "unit": "px"
    },
    "size.dialog.xs": {
      "value": 400,
      "unit": "px"
    },
    "size.editor": {
      "value": 400,
      "unit": "px"
    },
    "size.icon-circle": {
      "value": 60,
      "unit": "px"
    },
    "size.icon.lg": {
      "value": 24,
      "unit": "px"
    },
    "size.icon.md": {
      "value": 20,
      "unit": "px"
    },
    "size.icon.sm": {
      "value": 16,
      "unit": "px"
    },
    "size.icon.xl": {
      "value": 32,
      "unit": "px"
    },
    "size.icon.xs": {
      "value": 12,
      "unit": "px"
    },
    "size.input.lg": {
      "value": 300,
      "unit": "px"
    },
    "size.input.md": {
      "value": 200,
      "unit": "px"
    },
    "size.input.sm": {
      "value": 160,
      "unit": "px"
    },
    "size.input.xl": {
      "value": 400,
      "unit": "px"
    },
    "size.label": {
      "value": 150,
      "unit": "px"
    },
    "size.list": {
      "value": 300,
      "unit": "px"
    },
    "size.listbox-max": {
      "value": 250,
      "unit": "px"
    },
    "size.row": {
      "value": 60,
      "unit": "px"
    },
    "size.section": {
      "value": 400,
      "unit": "px"
    },
    "size.skeleton.40": {
      "value": 40,
      "unit": "px"
    },
    "size.skeleton.42": {
      "value": 42,
      "unit": "px"
    },
    "size.skeleton.56": {
      "value": 56,
      "unit": "px"
    },
    "size.skeleton.60": {
      "value": 60,
      "unit": "px"
    },
    "size.skeleton.72": {
      "value": 72,
      "unit": "px"
    },
    "size.skeleton.80": {
      "value": 80,
      "unit": "px"
    },
    "size.skeleton.84": {
      "value": 84,
      "unit": "px"
    },
    "size.skeleton.92": {
      "value": 92,
      "unit": "px"
    },
    "size.skeleton.96": {
      "value": 96,
      "unit": "px"
    },
    "size.skeleton.100": {
      "value": 100,
      "unit": "px"
    },
    "size.skeleton.114": {
      "value": 114,
      "unit": "px"
    },
    "size.skeleton.116": {
      "value": 116,
      "unit": "px"
    },
    "size.skeleton.119": {
      "value": 119,
      "unit": "px"
    },
    "size.skeleton.120": {
      "value": 120,
      "unit": "px"
    },
    "size.skeleton.128": {
      "value": 128,
      "unit": "px"
    },
    "size.skeleton.134": {
      "value": 134,
      "unit": "px"
    },
    "size.skeleton.140": {
      "value": 140,
      "unit": "px"
    },
    "size.skeleton.160": {
      "value": 160,
      "unit": "px"
    },
    "size.skeleton.180": {
      "value": 180,
      "unit": "px"
    },
    "size.skeleton.200": {
      "value": 200,
      "unit": "px"
    },
    "size.skeleton.220": {
      "value": 220,
      "unit": "px"
    },
    "size.skeleton.235": {
      "value": 235,
      "unit": "px"
    },
    "size.skeleton.240": {
      "value": 240,
      "unit": "px"
    },
    "size.skeleton.300": {
      "value": 300,
      "unit": "px"
    },
    "size.skeleton.320": {
      "value": 320,
      "unit": "px"
    },
    "size.skeleton.392": {
      "value": 392,
      "unit": "px"
    },
    "size.spacer": {
      "value": 80,
      "unit": "px"
    },
    "size.table-row": {
      "value": 54,
      "unit": "px"
    },
    "size.textarea": {
      "value": 150,
      "unit": "px"
    },
    "size.touch": {
      "value": 24,
      "unit": "px"
    },
    "space.0": {
      "value": 0,
      "unit": "px"
    },
    "space.1": {
      "value": 4,
      "unit": "px"
    },
    "space.2": {
      "value": 8,
      "unit": "px"
    },
    "space.2-5": {
      "value": 10,
      "unit": "px"
    },
    "space.3": {
      "value": 12,
      "unit": "px"
    },
    "space.4": {
      "value": 16,
      "unit": "px"
    },
    "space.5": {
      "value": 20,
      "unit": "px"
    },
    "space.6": {
      "value": 24,
      "unit": "px"
    },
    "space.8": {
      "value": 32,
      "unit": "px"
    },
    "space.10": {
      "value": 40,
      "unit": "px"
    },
    "space.12": {
      "value": 48,
      "unit": "px"
    },
    "space.16": {
      "value": 64,
      "unit": "px"
    },
    "space.20": {
      "value": 80,
      "unit": "px"
    },
    "space.24": {
      "value": 96,
      "unit": "px"
    },
    "space.gutter": {
      "value": 20,
      "unit": "px"
    },
    "typography.body": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 14,
        "unit": "px"
      },
      "lineHeight": {
        "value": 20,
        "unit": "px"
      },
      "fontWeight": 400
    },
    "typography.body-lg": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 16,
        "unit": "px"
      },
      "lineHeight": {
        "value": 24,
        "unit": "px"
      },
      "fontWeight": 400
    },
    "typography.body-lg-medium": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 16,
        "unit": "px"
      },
      "lineHeight": {
        "value": 24,
        "unit": "px"
      },
      "fontWeight": 500
    },
    "typography.body-medium": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 14,
        "unit": "px"
      },
      "lineHeight": {
        "value": 20,
        "unit": "px"
      },
      "fontWeight": 500
    },
    "typography.body-sm": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 13,
        "unit": "px"
      },
      "lineHeight": {
        "value": 20,
        "unit": "px"
      },
      "fontWeight": 400
    },
    "typography.body-sm-strong": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 13,
        "unit": "px"
      },
      "lineHeight": {
        "value": 20,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.body-strong": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 14,
        "unit": "px"
      },
      "lineHeight": {
        "value": 20,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.caption": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 12,
        "unit": "px"
      },
      "lineHeight": {
        "value": 16,
        "unit": "px"
      },
      "fontWeight": 400
    },
    "typography.caption-sm": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 11,
        "unit": "px"
      },
      "lineHeight": {
        "value": 14,
        "unit": "px"
      },
      "fontWeight": 400
    },
    "typography.caption-strong": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 12,
        "unit": "px"
      },
      "lineHeight": {
        "value": 16,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.display": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 56,
        "unit": "px"
      },
      "lineHeight": {
        "value": 68,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.heading-1": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 50,
        "unit": "px"
      },
      "lineHeight": {
        "value": 60,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.heading-2": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 24,
        "unit": "px"
      },
      "lineHeight": {
        "value": 32,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.heading-3": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 20,
        "unit": "px"
      },
      "lineHeight": {
        "value": 28,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.heading-4": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 16,
        "unit": "px"
      },
      "lineHeight": {
        "value": 24,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.label": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 13,
        "unit": "px"
      },
      "lineHeight": {
        "value": 20,
        "unit": "px"
      },
      "fontWeight": 500
    },
    "typography.label-sm": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 12,
        "unit": "px"
      },
      "lineHeight": {
        "value": 16,
        "unit": "px"
      },
      "fontWeight": 500
    },
    "typography.micro": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 10,
        "unit": "px"
      },
      "lineHeight": {
        "value": 12,
        "unit": "px"
      },
      "fontWeight": 400
    },
    "typography.micro-strong": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 10,
        "unit": "px"
      },
      "lineHeight": {
        "value": 12,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "typography.title": {
      "fontFamily": [
        "Pretendard",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif"
      ],
      "fontSize": {
        "value": 18,
        "unit": "px"
      },
      "lineHeight": {
        "value": 26,
        "unit": "px"
      },
      "fontWeight": 700
    },
    "z.base": 0,
    "z.dropdown": 1000,
    "z.modal": 1400,
    "z.overlay": 1300,
    "z.sticky": 1100,
    "z.sticky-content": 900,
    "z.toast": 1500,
    "z.tooltip": 1600
  },
  "modes": {}
}
